import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication, EventType, type AuthenticationResult } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { AuthProvider } from './contexts/AuthContext';
import { RepoProvider } from './contexts/RepoContext';
import { App } from './App';
import './styles/branding.css';
import './styles/main.css';

const msalInstance = new PublicClientApplication(msalConfig);

// Set the active account on first sign-in.
msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS) {
        const result = event.payload as AuthenticationResult;
        msalInstance.setActiveAccount(result.account);
    }
});

// Wrap MSAL initialization in an async IIFE so the bundle doesn't require
// top-level await (which esbuild can't transpile for the SPA browser target).
(async () => {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
        msalInstance.setActiveAccount(accounts[0]);
    }

    const rootElement = document.getElementById('root');
    if (!rootElement) throw new Error('Root element missing');

    createRoot(rootElement).render(
        <StrictMode>
            <MsalProvider instance={msalInstance}>
                <AuthProvider>
                    <RepoProvider>
                        <App />
                    </RepoProvider>
                </AuthProvider>
            </MsalProvider>
        </StrictMode>
    );
})();
